import { useCollection } from '@nandorojo/swr-firestore';
import { CollectionPath } from '@typings/collections.enum';
import React, { useCallback } from 'react';
import styled from 'styled-components';

const NeighborListWrap = styled.div``;
const NeighborLinkItem = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 4px;
  align-items: center;
  img {
    max-width: 100%;
  }
  transition: background-color 0.2s;

  &:hover {
    background-color: var(--inkColor);
  }
`;

type Props = {
  setNeighborLink: any;
};
function NeighborList({ setNeighborLink }: Props) {
  const { data } = useCollection<Ibanner>(CollectionPath.BANNER, {
    listen: true,
    orderBy: ['order', 'asc'],
  });

  const handleClickLink = useCallback((link) => {
    setNeighborLink(link);
  }, []);

  const list =
    data &&
    data.map((item, i) => {
      return (
        <NeighborLinkItem key={i} onClick={() => handleClickLink(item.linkto)}>
          <img src={item.imgURL || item.directImgURL} alt={item.name} />
          {item.name}
        </NeighborLinkItem>
      );
    });
  return <NeighborListWrap>{list}</NeighborListWrap>;
}

export default NeighborList;
